import Header from "./header";
import Slick from "./slick";
import MagnificPopup from "./magnific-popup";
import ContactForm from "./contact-form";
import AddToCart from "./add-to-cart";
import CartNumItems from "./cart-num-items";
import CartTotal from "./cart-total";
import CartSmall from "./cart-small";
import Checkout from "./checkout";
import PasswordChange from "./password-change";

export default {
    Header: Header,
    Slick: Slick,
    MagnificPopup: MagnificPopup,
    ContactForm: ContactForm,
    AddToCart: AddToCart,
    CartNumItems: CartNumItems,
    CartTotal: CartTotal,
    CartSmall: CartSmall,
    Checkout: Checkout,
    PasswordChange: PasswordChange
};


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/index.js
// module id = null
// module chunks = 